import _ from 'lodash';
import Vue from 'vue';

class BaseModel {
  // eslint-disable-next-line
  get defaults() {
    return {
      created_at: null,

      updated_at: null,
    };
  }

  // eslint-disable-next-line
  get maps() {
    return {};
  }

  constructor(props = {}) {
    this.assign(props);
  }

  assign(props = {}) {
    _.forEach(props, (value, key) => {
      if (this.maps[key] && typeof this.maps[key] === 'function') {
        this.maps[key](value);
      }
      if (this.maps[key] && typeof this.maps[key] !== 'function') {
        Vue.set(this, this.maps[key], value);
      }

      if (typeof this.defaults[key] !== 'undefined') {
        Vue.set(this, key, value);
      }
    });

    _.defaults(this, this.defaults);
  }

  set(key, value) {
    Vue.set(this, key, value);
  }
}

export default BaseModel;

